import {useContext} from 'react';
import {VirtualKeyboardContext} from './VirtualKeyboardContext';

export const useVirtualKeyboard = () => {
  const context = useContext(VirtualKeyboardContext);

  if (context === undefined) {
    return {
      handleFocus: () => {},
      handleBlur: () => {},
      isKeyboardVisible: false,
      activeFieldId: null,
      datepickerRefs: {},
      phoneInputRefs: {},
      countrySelectInputsRegister: () => ({
        value: undefined,
        setValue: undefined,
        onInputChange: undefined,
        onChange:
          <T>(userOnChange?: (option: T | null) => void) =>
          (option: T | null) => {
            userOnChange?.(option);
          },
      }),
      registerCustomField: () => () => {},
    };
  }

  return context;
};
